// extracted by mini-css-extract-plugin
export default {"Container":"FloatingActions_Container__ZrRii"};